import { QuestionResultsAverage } from './question-results-average';

export class CategoryResultsAverage {
    constructor(
      public hash?: string,
      public title?: string,
      public answerAVG?: number,
      public thumbnailImage?: string,
      public thumbnailPrimary?: string,
      public thumbnailSecondary?: string,
      public questionsResultsAverage?: QuestionResultsAverage[]
    ) { }

    clone() {
      return new CategoryResultsAverage(
        this.hash,
        this.title,
        this.answerAVG,
        this.thumbnailImage,
        this.thumbnailPrimary,
        this.thumbnailSecondary,
        this.questionsResultsAverage
      );
    }
  }

